module.exports = "<h2 id=\"wine\">WINE</h2>\n<p>Please have a look at our <a href=\"/static/wine.pdf\" target=\"_blank\">wine list</a>.<br>(vintages may vary)</p>\n";


//////////////////
// WEBPACK FOOTER
// ./src/assets/copy/wine_en.md
// module id = nMCl
// module chunks = 0